import React from 'react';
import {
  Modal,
  Alert,
} from 'antd';
import { DeleteOutlined, WarningOutlined } from '@ant-design/icons';
import { SavedWorkspaceState } from '../../types';

interface DeleteSavedStateDialogProps {
  isOpen: boolean;
  savedState: SavedWorkspaceState | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteSavedStateDialog: React.FC<DeleteSavedStateDialogProps> = ({
  isOpen,
  savedState,
  onConfirm,
  onCancel,
}) => {
  if (!savedState) return null;

  const formatTimestamp = (date: Date | undefined) => {
    if (!date) return 'Unknown time';
    
    const now = new Date();
    const timestamp = new Date(date); // Ensure it's a Date object
    const diff = now.getTime() - timestamp.getTime();
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (minutes < 60) {
      return `${minutes}m ago`;
    } else if (hours < 24) {
      return `${hours}h ago`;
    } else {
      return `${days}d ago`;
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      title={
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '0.5rem',
        }}>
          <WarningOutlined style={{ fontSize: '20px', color: 'var(--color-error)' }} />
          Delete saved state?
        </div>
      }
      okText="Delete"
      cancelText="Cancel"
      onOk={onConfirm}
      okButtonProps={{ danger: true }}
      width={400}
    >
        <Alert
          type="warning"
          message="This action cannot be undone"
          description="The saved workspace state will be permanently deleted."
          showIcon
          style={{ marginBottom: '1rem' }}
        />
        
        <div style={{
          padding: '1rem',
          backgroundColor: 'var(--color-bg-secondary)',
          borderRadius: '4px',
          border: '1px solid var(--color-border-primary)'
        }}>
          <div style={{
            fontSize: '0.875rem',
            fontWeight: '600',
            marginBottom: '0.25rem'
          }}>
            {savedState.name}
          </div>
          <div style={{
            fontSize: '0.75rem',
            opacity: 0.65
          }}>
            Saved {formatTimestamp(savedState.createdAt)}
          </div>
        </div>
    </Modal>
  );
};